var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadyForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 19.5H3C2.175 19.5 1.5 18.825 1.5 18V4.5C1.5 3.675 2.175 3 3 3H15C15.825 3 16.5 3.675 16.5 4.5V12.75C16.5 13.17 16.83 13.5 17.25 13.5C17.67 13.5 18 13.17 18 12.75V4.5C18 2.85 16.65 1.5 15 1.5H3C1.35 1.5 0 2.85 0 4.5V18C0 19.65 1.35 21 3 21H9.75C10.17 21 10.5 20.67 10.5 20.25C10.5 19.83 10.17 19.5 9.75 19.5ZM12.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5H12.75C13.17 7.5 13.5 7.17 13.5 6.75C13.5 6.33 13.17 6 12.75 6ZM13.5 11.25C13.5 10.83 13.17 10.5 12.75 10.5H5.25C4.83 10.5 4.5 10.83 4.5 11.25C4.5 11.67 4.83 12 5.25 12H12.75C13.17 12 13.5 11.67 13.5 11.25ZM5.25 15C4.83 15 4.5 15.33 4.5 15.75C4.5 16.17 4.83 16.5 5.25 16.5H8.25C8.67 16.5 9 16.17 9 15.75C9 15.33 8.67 15 8.25 15H5.25ZM22.335 13.665C22.05 13.38 21.585 13.38 21.3 13.665L15.735 19.23L13.215 16.71C12.93 16.425 12.48 16.425 12.21 16.71C11.925 16.995 11.925 17.445 12.21 17.715L15.09 20.595C15.12 20.67 15.165 20.73 15.225 20.79C15.51 21.075 15.975 21.075 16.26 20.79L22.35 14.7C22.62 14.415 22.62 13.95 22.335 13.665Z",
    fill: "#E5E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyForm);
export default __webpack_public_path__ + "static/media/readyForm.f94b579d0f6c383e99458f423706ac43.svg";
export { ForwardRef as ReactComponent };